// extracted by mini-css-extract-plugin
export default {"spinner":"components-CustomerSupportForms-Deliveries-styles__spinner--mOFhe","returnMsgLength":"components-CustomerSupportForms-Deliveries-styles__returnMsgLength--sssoz"};